import { ProductDto, ProductPriceDto } from '../../dto';
import { ProductIdType } from '../../types';
import { applyCookies, getCookies } from '../../utils/utils';
import { APIInterface } from './api.interface';
// const productsID = ['50174780', '50042571', '50130639', '400080526', '20047300', '40065650'];
// const productsID = ['20037456', '20042009', '20062528', '20042012'];
// MVID_CITY_ID,MVID_REGION_ID,MVID_REGION_SHOP,MVID_TIMEZONE_OFFSET

export class API implements APIInterface {
  private baseUrl: string;

  constructor() {
    // this.baseUrl = 'http://bff-18368164-staging2.web-staging2.yc.mvideo.ru'; // Local Dev;
    this.baseUrl = 'https://www.mvideo.ru/bff'; // Prod;

    // document.cookie = `MVID_CITY_ID=CityCZ_975;path=/;domain=.mvideo.ru`;
    // document.cookie = `MVID_REGION_ID=1;path=/;domain=.mvideo.ru`;
    // document.cookie = `MVID_REGION_SHOP=S002;path=/;domain=.mvideo.ru`;
    // document.cookie = `MVID_TIMEZONE_OFFSET=3;path=/;domain=.mvideo.ru`;

    applyCookies(getCookies());
  }

  public async getProducts(productsId: ProductIdType[]): Promise<ProductDto[]> {
    try {
      const response = await fetch(`${this.baseUrl}/product-details/list`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Cookie: document.cookie,
        },
        credentials: 'include',
        mode: 'cors',
        body: JSON.stringify({
          productIds: productsId,
          status: true,
          brand: true,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        return data.body.products;
      } else {
        throw new Error('Failed to fetch products');
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  }

  public async getPrices(
    productsId: ProductIdType[]
  ): Promise<ProductPriceDto[]> {
    try {
      const response = await fetch(
        `${
          this.baseUrl
        }/products/prices?productIds=${productsId.join()}&isPromoApplied=true`,
        {
          method: 'GET',
          headers: {
            // 'Content-Type': 'application/json',
            Cookie: document.cookie,
          },
          mode: 'cors',
          credentials: 'include',
        }
      );

      if (response.ok) {
        const data = await response.json();
        return data.body.materialPrices;
      } else {
        throw new Error('Failed to fetch prices');
      }
    } catch (error) {
      console.error('Error fetching prices:', error);
      throw error;
    }
  }
}
